import { Head, Link, usePage } from "@inertiajs/react";
import { MailX, Home, Bell } from "lucide-react";
import { Button } from "@/components/ui/button";

const TYPE_LABELS = {
  campaign_updates: "campaign updates",
  digests: "digest emails",
};

export default function Unsubscribe({ email_type }) {
  const label = TYPE_LABELS[email_type] || email_type.replace(/_/g, " ");
  const { auth } = usePage().props;

  return (
    <>
      <Head title="Unsubscribed" />
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="text-center space-y-6 max-w-md">
          <div className="mx-auto inline-flex h-16 w-16 items-center justify-center rounded-full bg-secondary text-muted-foreground">
            <MailX className="h-8 w-8" />
          </div>
          <div className="space-y-2">
            <h1 className="font-display text-3xl font-semibold text-foreground">
              You've been unsubscribed
            </h1>
            <p className="text-muted-foreground leading-relaxed">
              You won't receive any more {label} from PagePledge. You can change
              this any time in your email preferences.
            </p>
          </div>
          <div className="flex items-center justify-center gap-3 pt-2">
            {auth?.authenticated && (
              <Button asChild variant="outline">
                <Link href="/preferences">
                  <Bell className="h-4 w-4" />
                  Email preferences
                </Link>
              </Button>
            )}
            <Button asChild>
              <Link href="/">
                <Home className="h-4 w-4" />
                Home
              </Link>
            </Button>
          </div>
          <p className="text-xs text-muted-foreground pt-4">
            <a
              href="/"
              className="font-display font-semibold hover:text-primary transition-colors"
            >
              PagePledge<span className="text-primary">.</span>
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
